import { render, staticRenderFns } from "./ShowPnr.vue?vue&type=template&id=18811e72"
import script from "./ShowPnr.vue?vue&type=script&lang=js"
export * from "./ShowPnr.vue?vue&type=script&lang=js"
import style0 from "./ShowPnr.vue?vue&type=style&index=0&id=18811e72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports